// extracted by mini-css-extract-plugin
module.exports = {"search":"SearchBar_search__36r2_","input":"SearchBar_input__1cw-e","submit":"SearchBar_submit__3gHTA"};